/*
 * Title: Reconcile In Bulk - ItemRow
 * Description: Individual row component for the bulk reconciliation table
 */

import { Badge, Form, InputGroup } from 'react-bootstrap';
import { useReconcileInBulk } from './ContextAPI';

export default function ItemRow({ item, index }) {
    const {
        handleRowInput,
        runSimulate,
        openModal,
        rowInputs,
        rowStatuses,
    } = useReconcileInBulk();

    const status = rowStatuses[item.detail_id] || { type: 'equal', diff: 0 };

    const handleBlur = async () => {
        const qty = rowInputs[item.detail_id] ?? item.expected_qty;
        await runSimulate(item.detail_id, qty);
    };

    const getTypeBadge = () => {
        switch (status.type) {
            case 'gain':
                return <Badge bg="success" className="fs-6 px-2 py-1">GAIN (+{status.diff})</Badge>;
            case 'loss':
                return <Badge bg="danger" className="fs-6 px-2 py-1">LOSS ({status.diff})</Badge>;
            default:
                return <Badge bg="info" className="fs-6 px-2 py-1">EQUAL</Badge>;
        }
    };

    const handleInputChangeWrapper = (e) => {
        const qty = e.target.value === '' ? 0 : e.target.value;
        handleRowInput(item.detail_id, qty);
    };

    const batchDisplay = item.batch_no && item.batch_no.toUpperCase() === 'N/A' ? 'N/A' : item.batch_no;

    return (
        <tr className={status.type === 'gain' ? 'table-success' : status.type === 'loss' ? 'table-danger' : ''}>
            <td className="text-center">{index + 1}</td>
            <td><strong>{item.code_no}</strong></td>
            <td>{item.drug_name}</td>
            <td>{item.po_no}</td>
            <td style={{ width: '120px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{batchDisplay}</td>
            <td className="text-end">{item.receive_qty?.toLocaleString()}</td>
            <td className="text-end"><strong>{item.available_qty?.toLocaleString()}</strong></td>
            <td className="text-end">{item.dispatch_qty?.toLocaleString()}</td>
            <td>
                <InputGroup size="sm" className="w-100">
                    <Form.Control
                        type="number"
                        min="0"
                        value={rowInputs[item.detail_id] ?? item.expected_qty}
                        onChange={handleInputChangeWrapper}
                        onBlur={handleBlur}
                        className="text-end"
                        placeholder="Expected Qty"
                    />
                    <InputGroup.Text className="bg-light">{getTypeBadge()}</InputGroup.Text>
                </InputGroup>
            </td>
            <td>
                {status.type !== 'equal' && (
                    <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={() => {
                            openModal({ ...item, expected_qty: rowInputs[item.detail_id] ?? item.expected_qty, status });
                        }}
                    >
                        Reconcile
                    </button>
                )}
                {status.type === 'equal' && <span className="text-muted small">No action needed</span>}
            </td>
        </tr>
    );
}